
import BaseModal from "@/components/shared/modals/BaseModal";
import SelectInput from "@/components/shared/inputs/SelectInput";
import { useTranslation } from "react-i18next";

export default function AssignHiringTeamModal({ onOpenChange, open }) {
  const { t } = useTranslation();

  const handleAddPool = () => {
    console.log("Adding new talent pool...");
    onOpenChange(false);
  };

  return (
    <BaseModal
      open={open}
      onClose={() => onOpenChange(false)}
      onConfirm={handleAddPool}
      title={t("assignHiringTeamModal.title")}
      textBtn={t("assignHiringTeamModal.assignButton")}
    >
      <div className="space-y-4 pt-4 pb-6">
        <SelectInput
          required
          label={t("assignHiringTeamModal.recruiterLabel")}
          placeholder={t("assignHiringTeamModal.recruiterPlaceholder")}
          className=" w-full !h-[3rem] rounded-[1rem]"
        />
        <SelectInput
          required
          label={t("assignHiringTeamModal.hiringManagerLabel")}
          placeholder={t("assignHiringTeamModal.hiringManagerPlaceholder")}
          className=" w-full !h-[3rem] rounded-[1rem]"
        />
        <SelectInput
          required
          label={t("assignHiringTeamModal.participantsLabel")}
          placeholder={t("assignHiringTeamModal.participantsPlaceholder")}
          className=" w-full !h-[3rem] rounded-[1rem]"
        />
      </div>
    </BaseModal>
  );
}
